import { render, staticRenderFns } from "./myself.vue?vue&type=template&id=0d716e7a&scoped=true"
import script from "./myself.vue?vue&type=script&lang=js"
export * from "./myself.vue?vue&type=script&lang=js"
import style0 from "./myself.vue?vue&type=style&index=0&id=0d716e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d716e7a",
  null
  
)

export default component.exports